import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var generateStyle = function generateStyle(componentTheme) {
  var printMq = '@media print';
  return {
    fileDropContent: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: "".concat(componentTheme.fileDropContentPadding, " 0"),
      backgroundColor: componentTheme.fileDropContentBackgroundColor
    },
    fileDropContentIcon: {
      display: 'flex',
      fontSize: componentTheme.fileDropContentIconFontSize
    },
    fileDropContentLabel: {
      paddingLeft: componentTheme.fileDropContentLabelPadding,
      display: 'flex',
      fontFamily: componentTheme.fileDropContentFontFamily
    },
    fileDropContentLabelBrowse: {
      paddingLeft: componentTheme.fileDropContentLabelBrowsePadding,
      color: componentTheme.fileDropContentLabelBrowseColor,
      textDecoration: 'underline'
    },
    printOnly: _defineProperty({
      display: 'none'
    }, printMq, {
      display: 'block'
    })
  };
};
export default generateStyle;